export default __webpack_public_path__ + "static/media/after@3x.a0593e8d.png";